import { INIT_REQUEST, INIT_SUCCESS } from '../actions';

const initialState = {
    state: 'idle'
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case INIT_REQUEST:
            return {
                ...state,
                state: 'loading'
            };
        case INIT_SUCCESS:
            return {
                ...state,
                state: 'success'
            };
        default:
            return state;
    }
}
